import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ListinoItem } from '../../listino/listinoInterfaces';
import { AppDispatch } from '..';
import axios from 'axios';
import { errorDialogDefaultFunction } from '@bludata/utility-functions';
import { Articoli_fornitore_table_interface } from '@bludata/common-interfaces';
import { RicercaArticoloFiltered_interface } from '../../magazzino/anagrafica/interfaces/RicercaArticoloFiltered_interface';
import RicercaMagazzino from '@focus.cloud/src/interface/RicercaMagazzino';

export interface ListinoSliceState {
  magazzinoSelected: number;
  listinoPage: number;
  listino: RicercaMagazzino;
  listinoLoading: boolean;
  listinoEdit: Articoli_fornitore_table_interface;
}

const initialState: ListinoSliceState = {
  magazzinoSelected: 0,
  listinoPage: 0,
  listino: undefined,
  listinoLoading: false,
  listinoEdit: undefined,
};

const ListinoSlice = createSlice({
  name: 'listino',
  initialState,
  reducers: {
    setListinoSelected(
      state: ListinoSliceState,
      action: PayloadAction<number>,
    ) {
      state.magazzinoSelected = action.payload;
    },
    setListinoPage(state: ListinoSliceState, action: PayloadAction<number>) {
      state.listinoPage = action.payload;
    },
    setListino(
      state: ListinoSliceState,
      action: PayloadAction<RicercaMagazzino>,
    ) {
      state.listino = action.payload;
    },
    setListinoLoading(
      state: ListinoSliceState,
      action: PayloadAction<boolean>,
    ) {
      state.listinoLoading = action.payload;
    },
    setListinoEdit(
      state: ListinoSliceState,
      action: PayloadAction<Articoli_fornitore_table_interface>,
    ) {
      state.listinoEdit = action.payload;
    },
  },
});

export const {
  setListinoSelected,
  setListino,
  setListinoLoading,
  setListinoPage,
  setListinoEdit,
} = ListinoSlice.actions;

export default ListinoSlice.reducer;
